export enum ClientType {
    // 法人
    Enterprise = 1,
    // 個人
    Personal = 2,
}